import { translate } from 'utils/translate';
import { formatDigitalLoanMoney } from './moneyInput';

/**
 * Explica el tope con los montos de la respuesta.
 * No recalcula el máximo ni sustituye el monto ofrecido.
 */
export function buildCappedLoanMessage(literal, source) {
  if (source?.cappedByMaxAmount !== true) return '';
  if (source.appraisalAmount == null || source.maxLoanAmount == null) {
    return '';
  }
  return translate(literal || '', {
    appraisal: formatDigitalLoanMoney(source.appraisalAmount),
    maxAmount: formatDigitalLoanMoney(source.maxLoanAmount),
  });
}
